import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-delete-jurisdiction-confirmation-dialog',
	templateUrl: './delete-jurisdiction-confirmation-dialog.component.html',
	standalone: false,
})
export class DeleteJurisdictionConfirmationDialogComponent {
	constructor(
		private matDialogRef: MatDialogRef<DeleteJurisdictionConfirmationDialogComponent>,
	) {}

	onAccept() {
		this.matDialogRef.close(true);
	}

	onCancel() {
		this.matDialogRef.close(false);
	}
}
